<template>
  <div class="baseSet">
    <h1>基本设置</h1>
    <a-form-model
      :model="form"
      :rules="modleRules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
      ref="infoForm"
      class="baseForm"
    >
      <a-form-model-item label="姓名" ref="name" prop="name">
        <a-input v-model="form.name" :maxLength="30"/>
      </a-form-model-item>
      <a-form-model-item label="性别" ref="gender" prop="gender">
        <a-radio-group v-model="form.gender">
          <a-radio :value="1">男</a-radio>
          <a-radio :value="0">女</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="个人简介">
        <a-input v-model="form.introduction" type="textarea"/>
      </a-form-model-item>
      <a-form-model-item label="头像">
          <a-upload
            name="imgFile"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :headers="headers"
            :action=" baseURL"
            @change="changeIcon"
            :before-upload="beforeIcon"
          >
            <div v-if="form.profilePhoto">
              <a-icon
                v-show="imgLoading"
                style="position: absolute; top: 45%; left: 45%"
                type="loading"
              />
              <img style="max-width: 100px;max-height: 100px" :src="form.profilePhoto | filterUrl" alt="avatar">
            </div>
            <div v-else>
              <a-icon :type="iconloading ? 'loading' : 'plus'"/>
            </div>
          </a-upload>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 1}">
        <a-button type="primary" @click="onSubmit" :disabled="subLoading">保存信息</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import Apis from "@/requests/apis";
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}
export default {
  name: "baseSet",
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 24 },
      form: {
        name: "",
        introduction: "",
        gender: 1,
        profilePhoto:'',
      },
      modleRules: {
        name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
        gender: [{ required: true, message: "请填写姓名", trigger: "change" }],
      },
      subLoading:false,
      info: this.$store.getters["account/user"],
      iconloading: false,
      imgLoading: false,
      baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=user/face",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token")
      },
    };
  },
  created() {
    this.getAdminInfo()
  },
  methods: {
    getAdminInfo(){
      let parmas = {
          adminId:this.info.Id || this.info.id
      }
      this.$http.getAdminInfo(parmas)
      .then((res) => {
          this.info = res.data.data
          this.form = {
              id: this.info.id,
            name: this.info.name,
            introduction: this.info.introduction,
            gender: this.info.gender,
            profilePhoto: this.info.profilePhoto,
          }
       
      })
    },
    changeIcon(info) {
      if (info.fileList[0].response) {
        this.form.profilePhoto = info.fileList[0].response.data;
      }
      if (info.file.status === "uploading") {
        this.iconloading = true;
        this.imgLoading = true;
        return;
      }
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, imageUrl => {
          this.form.profilePhoto = info.file.response.data;
          this.iconloading = false;
          this.imgLoading = false;
        });
      }
    },
    beforeIcon(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传jpg或者png图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过2M!");
      }
      return isJpgOrPng && isLt2M;
    },
    onSubmit() {
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          this.subLoading = true
          this.$http.updateInfo(this.form)
          .then(res=> {
              this.$message.success('修改成功')
              this.getAdminInfo();
          
            this.subLoading = true
          })
        }else {

        }
      });
      
    },
  }
};
</script>

<style scoped lang="less">
.baseSet {
  width: 100%;
  h1 {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  .ant-form-item {
    width: 25%;
    display: flex !important;
    flex-direction: column;
  }
}
// .iconUploadBox {
//   position: absolute;
//   top: 0;
//   right: 0;
//   width: auto;
// }
</style>
